<template>
    <b-container fluid class="animated fadeIn">
        <h1>Incluir / Alterar Comarca</h1>
        <b-card>
            <b-row>
                <b-col xs="12" sm="12" md="8" lg="8" xl="8">
                    <b-form-group label="Nome: *" label-for="nome" class="text-label">
                        <b-form-input 
                            name="nome"
                            v-model="comarca.nome" 
                            type="text" 
                            maxlength="150"
                            v-validate="{ required: true }"/>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col xs="12" sm="12" md="4" lg="4" xl="4">
                    <b-form-group label="Nome Simplificado: *" label-for="nomeSimplificado" class="text-label">
                        <b-form-input 
                            name="nomeSimplificado"
                            v-model="comarca.nomeSimplificado" 
                            type="text" 
                            maxlength="150"
                            v-validate="{ required: true }" />
                    </b-form-group>
                </b-col>
                <b-col xs="12" sm="12" md="4" lg="4" xl="4">
                    <b-form-group label="Código TJ: *" label-for="codigoTabelaTJ" class="text-label">
                        <b-form-input 
                            name="codigoTabelaTJ"
                            v-model="comarca.codigoTabelaTj" 
                            type="number"
                            v-validate="{ required: true , max: 8 }" />
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col xs="12" sm="12" md="4" lg="4" xl="4">
                    <b-form-group label="Sigla: *" label-for="sigla" class="text-label">
                        <b-form-input 
                            name="sigla"
                            v-model="comarca.sigla" 
                            type="text" 
                            maxlength="12"
                            v-validate="{ required: true }" />
                    </b-form-group>
                </b-col>
                <b-col xs="12" sm="12" md="4" lg="4" xl="4">
                    <b-form-group label="Última Remessa:" label-for="ultimoSeqRemessaH8" class="text-label">
                        <b-form-input 
                            name="ultimoSeqRemessaH8"
                            v-model="comarca.ultimoSeqRemessaH8" 
                            type="number"
                            v-validate="{ max: 8 }" />
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col xs="12" sm="12" md="4" lg="4" xl="4">
                    <b-form-group label="Município Sede Protesto:" label-for="municipioSedeProtesto" class="text-label">
                        <multiselect
                            name="municipioSedeProtesto"
                            v-model="comarca.sedeProtesto"
                            :show-labels="false"
                            :options="dados.municipios"
                            :multiple="false"
                            :close-on-select="true"
                            :clear-on-select="true"
                            :preserve-search="false"
                            placeholder="Selecione"
                            track-by="codMunicipio"
                            label="nome"
                        >
                        </multiselect>
                    </b-form-group>
                </b-col>
                <b-col xs="12" sm="12" md="4" lg="4" xl="4">
                    <b-form-group label="Município Sede Ajuizamento:" label-for="municipioSedeAjuizamento" class="text-label">
                        <multiselect
                            name="municipioSedeAjuizamento"
                            v-model="comarca.sedeAjuizamento"
                            :show-labels="false"
                            :options="dados.municipios"
                            :multiple="false"
                            :close-on-select="true"
                            :clear-on-select="true"
                            :preserve-search="false"
                            placeholder="Selecione"
                            track-by="codMunicipio"
                            label="nome"
                        >
                        </multiselect>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col>
                    <b-form-group label="" label-for="homologadaCra" class="text-label">
                        <b-form-checkbox v-model="comarca.homologadaCra" >Homologada na CRA</b-form-checkbox>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col xs="12" sm="12" md="4" lg="4" xl="4">
                    <b-form-group
                        id="groupAtivo"
                        label="Situação: *"
                        label-for="ativo">
                        <b-form-checkbox switch v-model="comarca.indAtivo">{{ comarca.indAtivo ? 'Ativo' : 'Inativo'}}</b-form-checkbox>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col xs="8" sm="8" md="8" lg="8" xl="8">
                    <b-tabs content-class="mt-3" fill>
                        <b-tab title="Ajuizamento" active>
                            <b-row>
                                <b-col xs="12" sm="12" md="12" lg="12" xl="12">
                                    <b-form-group label="Município: " label-for="municipioAjuizamento" class="text-label">
                                        <b-form inline>
                                            <div class="col-md-10 col-lg-10 col-xl-10 col-sm-12 col-xs-12 p-0 m-0">
                                                <multiselect
                                                    name="municipioAjuizamento"
                                                    v-model="municipioAjuizamento"
                                                    :show-labels="false"
                                                    :options="dados.municipiosAjuizamento"
                                                    :multiple="false"
                                                    :close-on-select="true"
                                                    :clear-on-select="true"
                                                    :preserve-search="false"
                                                    placeholder="Selecione"
                                                    track-by="codMunicipio"
                                                    label="nome"
                                                >
                                                </multiselect>
                                            </div>
                                            <b-button variant="primary" class="fonte-branca ml-1" @click.prevent="adicionarAjuizamento">
                                                <i class="fa fa-plus"></i> Adicionar
                                            </b-button>
                                        </b-form>
                                    </b-form-group>
                                </b-col>
                            </b-row>
                            <b-row class="d-flex justify-content-between">
                                <b-col></b-col>
                                <b-col>
                                    <div>
                                        <b-pagination v-model="configTableMunicipioAjuizamento.currentPage" :per-page="configTableMunicipioAjuizamento.perPage" :total-rows="configTableMunicipioAjuizamento.rows" size="sm" class="pl-3" style="float:right" v-if="configTableMunicipioAjuizamento.perPage != 'Todos'">
                                        </b-pagination>
                                        <b-form-select v-model="configTableMunicipioAjuizamento.perPage" :options="[100, 500, 1000, 'Todos']" size="sm" class="mb-3 col-3" style="float:right"></b-form-select>
                                    </div>
                                </b-col>
                            </b-row>
                            <TabelaMunicipio
                                :municipios="comarca.municipiosAjuizamento"
                                :fields="fieldsAjuizamento"
                                @excluir="excluirAjuizamento"
                                :configTable="configTableMunicipioAjuizamento" />
                            <b-row class="d-flex justify-content-between">
                                <b-col></b-col>
                                <b-col>
                                    <div>
                                        <div>
                                            <b-pagination v-model="configTableMunicipioProtesto.currentPage" :per-page="configTableMunicipioProtesto.perPage" :total-rows="configTableMunicipioProtesto.rows" size="sm" class="pl-3" style="float:right" v-if="configTableMunicipioProtesto.perPage != 'Todos'">
                                            </b-pagination>
                                            <b-form-select v-model="configTableMunicipioProtesto.perPage" :options="[100, 500, 1000, 'Todos']" size="sm" class="mb-3 col-3" style="float:right"></b-form-select>
                                        </div>
                                    </div>
                                </b-col>
                            </b-row>
                        </b-tab>
                        <b-tab title="Protesto">
                            <b-row>
                                <b-col xs="12" sm="12" md="12" lg="12" xl="12">
                                    <b-form-group label="Município: " label-for="municipioProtesto" class="text-label">
                                        <b-form inline>
                                            <div class="col-md-10 col-lg-10 col-xl-10 col-sm-12 col-xs-12 p-0 m-0">
                                                <multiselect
                                                    name="municipioProtesto"
                                                    v-model="municipioProtesto"
                                                    :show-labels="false"
                                                    :options="dados.municipiosProtesto"
                                                    :multiple="false"
                                                    :close-on-select="true"
                                                    :clear-on-select="true"
                                                    :preserve-search="false"
                                                    placeholder="Selecione"
                                                    track-by="codMunicipio"
                                                    label="nome"
                                                >
                                                </multiselect>
                                            </div>
                                            <b-button variant="primary" class="fonte-branca ml-1" @click.prevent="adicionarProtesto">
                                                <i class="fa fa-plus"></i> Adicionar
                                            </b-button>
                                        </b-form>
                                    </b-form-group>
                                </b-col>
                            </b-row>
                            <b-row class="d-flex justify-content-between">
                                <b-col></b-col>
                                <b-col>
                                    <div>
                                        <b-pagination v-model="configTableMunicipioProtesto.currentPage" :per-page="configTableMunicipioProtesto.perPage" :total-rows="configTableMunicipioProtesto.rows" size="sm" class="pl-3" style="float:right" v-if="configTableMunicipioProtesto.perPage != 'Todos'">
                                        </b-pagination>
                                        <b-form-select v-model="configTableMunicipioProtesto.perPage" :options="[100, 500, 1000, 'Todos']" size="sm" class="mb-3 col-3" style="float:right"></b-form-select>
                                    </div>
                                </b-col>
                            </b-row>
                            <TabelaMunicipio
                                :municipios="comarca.municipiosProtesto"
                                :fields="fieldsProtesto"
                                @excluir="excluirProtesto"
                                :configTable="configTableMunicipioProtesto" />
                            <b-row class="d-flex justify-content-between">
                                <b-col></b-col>
                                <b-col>
                                    <div>
                                        <b-pagination v-model="configTableMunicipioProtesto.currentPage" :per-page="configTableMunicipioProtesto.perPage" :total-rows="configTableMunicipioProtesto.rows" size="sm" class="pl-3" style="float:right" v-if="configTableMunicipioProtesto.perPage != 'Todos'">
                                        </b-pagination>
                                        <b-form-select v-model="configTableMunicipioProtesto.perPage" :options="[100, 500, 1000, 'Todos']" size="sm" class="mb-3 col-3" style="float:right"></b-form-select>
                                    </div>
                                </b-col>
                            </b-row>
                        </b-tab>
                    </b-tabs>
                </b-col>
            </b-row>
            <b-row>
                <b-col xs="12" sm="12" md="4" lg="4" xl="4">
                    <b-button variant="primary" @click.prevent="salvar" :disabled="inSave">
                        <i class="fa fa-save"></i> Salvar
                    </b-button>
                    <b-button variant="primary" class="ml-2" @click="voltar">
                        <i class="fa fa-reply"></i> Voltar
                    </b-button>
                </b-col>
            </b-row>
        </b-card>
    </b-container>
</template>

<script>
import axios from 'axios'
import TabelaMunicipio from './TabelaMunicipio'
import formatarMixins from '../../../mixins/formatarMixins'

export default {
    name: 'ManterComarcaEditar',
    mixins: [ formatarMixins ],
    components: {
        TabelaMunicipio
    },
    data() {
        return {
            inSave: false,
            municipioAjuizamento: null,
            municipioProtesto: null,
            comarca: {
                nome: null,
                sigla: null,
                nomeSimplificado: null,
                codigoTabelaTj: null,
                ultimoSeqRemessaH8: null,
                sedeProtesto: null,
                sedeAjuizamento: null,
                homologadaCra: false,
                indAtivo: true,
                municipiosAjuizamento: [],
                municipiosProtesto: []
            },
            dados: {
                municipios: [],
                municipiosAjuizamento: [],
                municipiosProtesto: []

            },
            configTableMunicipioAjuizamento: {
                perPage: 100,
                currentPage: 1,
                rows: 0,
            },
            configTableMunicipioProtesto: {
                perPage: 100,
                currentPage: 1,
                rows: 0,
            },
            fieldsAjuizamento: [
                {
                    key: 'nome',
                    label: 'Município de Ajuizamento'
                },
                {
                    key: 'dataInclusao',
                    label: 'Data Inclusão',
                    class: 'text-center'
                },
                {
                    key: 'excluir',
                    label: 'Excluir',
                    class: 'text-center'
                }
            ],
            fieldsProtesto: [
                {
                    key: 'nome',
                    label: 'Município de Protesto'
                },
                {
                    key: 'dataInclusao',
                    label: 'Data Inclusão',
                    class: 'text-center'
                },
                {
                    key: 'excluir',
                    label: 'Excluir',
                    class: 'text-center'
                }
            ]
        }
    },
    watch: {
        getMunicipiosAjuizamento() {
            this.atualizarTabelas()
        },
        getMunicipiosProtesto() {
            this.atualizarTabelas()
        }

    },
    computed: {
        getMunicipiosAjuizamento() {
            return this.comarca.municipiosAjuizamento
        },
        getMunicipiosProtesto() {
            return this.comarca.municipiosProtesto
        }
    },
    methods: {

        salvar() {
            this.inSave = true
            this.$validator.validateAll().then( async (result) => {
                if (!result) {
                    this.$store.commit("setMessages", { message: 'Atenção', variant: 'danger' , errors: ['Favor preencher os campos obrigatórios (*)'] });
                    this.inSave = false
                    window.scrollTo(0,0);
                    return
                }

                const urlApi = process.env.VUE_APP_ROOT_API
                const token = JSON.parse(this.$store.getters.getUser).token.access_token

                const comarca = {
                    ...this.comarca
                }

                await axios.post(`${urlApi}/v1/comarca/salvar`, comarca, {
                    headers: {
                        'Authorization': token,
                        'Content-Type': 'application/json',
                    }
                })
                .then(response => {
                    if(response.data) {
                        this.$store.commit("setMessages", { message: 'Atenção', variant: 'danger' , errors: [`${response.data.message}`] });
                        window.scrollTo(0,0);
                        return
                    }
                    this.$store.commit("setMsgComarca", 'Operação realizada com sucesso!!!')
                    this.$store.commit("setComarca", null);
                    this.$router.push({ path: '/comarca' })
                }).catch((error) => {
                    this.exibirErro(error)
                }).finally(() => {
                    this.inSave = false
                })
            })
        },

        voltar() {
            this.$store.commit("setComarca", null);
            this.$router.push({ path: '/comarca' })
        },

        adicionarAjuizamento() {
            if(!this.municipioAjuizamento) {
                this.$store.commit("setMessages", { message: 'Atenção', variant: 'danger' , errors: ['Selecionar um município para adicionar.'] });
                window.scrollTo(0,0);
                return
            } else {
                const municipioExiste = this.comarca.municipiosAjuizamento.filter(m => this.municipioAjuizamento.codMunicipio === m.codMunicipio)
                if(!municipioExiste.length) {
                    const { codMunicipio, nome } = this.municipioAjuizamento
                    const dataInclusao = this.formatarData(new Date())
                    this.comarca.municipiosAjuizamento.push({ codMunicipio, nome, dataInclusao })
                } else {
                    this.$store.commit("setMessages", { message: 'Atenção', variant: 'danger' , errors: ['O município informado já se encontra adicionado a lista.'] });
                    window.scrollTo(0,0);
                }
            }

            this.municipioAjuizamento = null

            this.listarMunicipios()
        },


        adicionarProtesto() {
            if(!this.municipioProtesto) {
                this.$store.commit("setMessages", { message: 'Atenção', variant: 'danger' , errors: ['Selecionar um município para adicionar.'] });
                window.scrollTo(0,0);
                return
            } else {
                const municipioExiste = this.comarca.municipiosProtesto.filter(m => this.municipioProtesto.codMunicipio === m.codMunicipio)
                if(!municipioExiste.length) {
                    const { codMunicipio, nome } = this.municipioProtesto
                    const dataInclusao = this.formatarData(new Date())
                    this.comarca.municipiosProtesto.push({ codMunicipio, nome, dataInclusao })
                } else {
                    this.$store.commit("setMessages", { message: 'Atenção', variant: 'danger' , errors: ['O município informado já se encontra adicionado a lista.'] });
                    window.scrollTo(0,0);
                }

            }

            this.municipioProtesto = null

            this.listarMunicipios()
        },

        atualizarTabelas() {
            this.configTableMunicipioAjuizamento.rows = this.comarca.municipiosAjuizamento.length
            this.configTableMunicipioProtesto.rows = this.comarca.municipiosProtesto.length
        },

        excluirAjuizamento(item) {
            if(item) {
                const index = this.comarca.municipiosAjuizamento.indexOf(item)
                this.comarca.municipiosAjuizamento.splice(index, 1)
                this.listarMunicipios()
            }
        },

        excluirProtesto(item) {
            if(item) {
                const index = this.comarca.municipiosProtesto.indexOf(item)
                this.comarca.municipiosProtesto.splice(index, 1)
                this.listarMunicipios()
            }
        },

        /**
         * Exibe erros dos catch
         */
        exibirErro(error) {
            this.$store.commit("setMessages", { message: 'Erro!', errors: [error] });
        },

        /**
         * Listar municípios
         */
        async listarMunicipios() {
            const urlApi = process.env.VUE_APP_ROOT_API

            axios.get(`${urlApi}/v1/municipio/listarPR`)
            .then(response => {
                this.dados.municipios = response.data
                this.dados.municipiosAjuizamento = [ ...response.data ]
                this.dados.municipiosProtesto = [ ...response.data ]

                if(this.comarca.municipiosAjuizamento.length) {
                    this.comarca.municipiosAjuizamento.forEach( mLista => {
                        const filterMunicipio = this.dados.municipiosAjuizamento.filter( mBanco => mLista.codMunicipio === mBanco.codMunicipio)
                        if(filterMunicipio.length) {
                            const index = this.dados.municipiosAjuizamento.indexOf(filterMunicipio[0])
                            this.dados.municipiosAjuizamento.splice(index, 1)
                        }
                    })
                }
                if(this.comarca.municipiosProtesto.length) {
                    this.comarca.municipiosProtesto.forEach( mLista => {
                        const filterMunicipio = this.dados.municipiosProtesto.filter( mBanco => mLista.codMunicipio === mBanco.codMunicipio)
                        if(filterMunicipio.length) {
                            const index = this.dados.municipiosProtesto.indexOf(filterMunicipio[0])
                            this.dados.municipiosProtesto.splice(index, 1)
                        }
                    })
                }
            })
        },

        async obterComarca(codComarca) {
            const urlApi = process.env.VUE_APP_ROOT_API
            const token = JSON.parse(this.$store.getters.getUser).token.access_token

            await axios.post(`${urlApi}/v1/comarca/obter`, codComarca, {
                headers: {
                    'Authorization': token,
                    'Content-Type': 'application/json',
                }
            })
            .then(response => {
                this.comarca = response.data
            }).catch((error) => {
                this.exibirErro(error)
            })
        },
    },
    mounted() {
        this.$store.commit("setMessages", {});

        const comarcaEditada = this.$store.getters.getComarca;
        if(comarcaEditada) {
            this.obterComarca(comarcaEditada.codComarca)
        }

        this.listarMunicipios()
        this.atualizarTabelas()

    }
    
}
</script>

<style scoped>


</style>